import type { FaireProductEntity } from "../../entity_types/product";

export const p_6q5nyrfxb6: FaireProductEntity = {
  token: "p_6q5nyrfxb6",
  type: "product",
  name: "Oh Deer Winter Is Here Shopping Tote",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/6955110545227996bc4461f11f25b29073b6dd5433903c47e3a9586761a7c8ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cb85bb7238fed8a4223ff993bb971453e71fb8ea20f8e6dfdf73396adcadd1a.jpeg",
    "https://cdn.faire.com/fastly/70175a90523fa625939bfed131a07c63d53d4524993e42a43abfa73e05326e12.jpeg"
  ],
  priceDollars: 7,
  description: "A shopping tote from our Christmas Collection featuring a double-sided design displaying vintage art of deer on a snowy mountain with a fun deer pun that reads \"Oh Deer, Winter Is Here.\" Winter tote gussets display coordinating blue color. Seasonal market tote includes both hand and shoulder straps in blue nylon and a convenient inside pocket displaying a snowflake pattern. Our Oh Deer Winter Is Here shopping tote is made from eco-friendly post-consumer material and folds flat for compact storage. A fun winter tote perfect for a seasonal accessory and great for reusable gift wrapping.",
  tags: [],
  msrpDollars: 13.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:25.620Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
